import OriginalCarImageIcon from "@/assets/illustrations/OriginalCarImageIcon.svg";
import { useState } from "react";
import { EditDialog } from "@/components/custom/EditDialog";

type CheckInCardProps = {
  vehicleNumber?: string;
  pilotName?: string;
  timeSinceAllocated?: string;
  odometer?: number;
  soc?: number;
  canValidityScore?: string;
  efficiencyScore?: string;
  hubName?: string;
  setOdo: (odo: number) => void;
  setSoc: (soc: number) => void;
};

const CheckInCard = ({
  vehicleNumber = "—",
  pilotName = "—",
  timeSinceAllocated = "—",
  odometer = 0,
  soc = 0,
  canValidityScore = "—",
  efficiencyScore = "—",
  hubName = "-",
  setOdo,
  setSoc,
}: CheckInCardProps) => {
  const [odo, setLocalOdo] = useState(odometer);
  const [editedSoc, setLocalSoc] = useState(soc);

  const handleOdoSave = (newOdo: number) => {
    setLocalOdo(newOdo);
    setOdo(newOdo);
  };

  const handleSocSave = (newSoc: number) => {
    setLocalSoc(newSoc);
    setSoc(newSoc);
  };

  return (
    <div className="w-5/6 shadow-[0px_2px_0px_#3ebec8] rounded-[30px] box-border border-2 border-solid border-primary flex justify-center items-center p-4 bg-white">
      <div className="flex flex-col gap-2 items-center ">
        <h1>Check-In Details</h1>
        <h3 className="text-primary">{hubName}</h3>
        <img src={OriginalCarImageIcon} className="w-60" />
        <div className="grid grid-cols-2 gap-8 mt-8">
          <div className="flex flex-col items-center">
            <p>Vehicle Number</p>
            <h5 className="font-bold">{vehicleNumber}</h5>
          </div>
          <div className="flex flex-col items-center">
            <p>Pilot Name</p>
            <h5 className="font-bold">{pilotName}</h5>
          </div>
        </div>
        <div className="flex flex-col items-center ">
          <p>Time Since Allocated</p>
          <h3>{timeSinceAllocated}</h3>
        </div>
        <div className="grid grid-cols-2 gap-8 mt-4">
          <div className="flex flex-col items-center">
            <div className="flex flex-row items-center">
              <h3>Odometer</h3>
              <EditDialog
                title="Edit Odometer Reading"
                description="Update the odometer reading below."
                initialValue={odo}
                onSave={handleOdoSave}
                label="Odometer"
                unit="KM"
              />
            </div>
            <h5 className="text-primary">
              {odo != null ? `${odo.toFixed(2)} KM` : "—"}
            </h5>
          </div>
          <div className="flex flex-col items-center">
            <div className="flex flex-row items-center">
              <h3>SOC</h3>
              <EditDialog
                title="Edit SOC Reading"
                description="Update the SOC reading below."
                initialValue={editedSoc}
                onSave={handleSocSave}
                label="SOC"
                unit="%"
                type="soc"
              />
            </div>
            <h5 className="text-primary">
              {editedSoc != null ? `${editedSoc}%` : "—"}
            </h5>
          </div>
        </div>
        <div className="grid grid-cols-2 gap-8 mt-4">
          <div className="flex flex-col items-center">
            <p>Validity Score</p>
            <h5>{canValidityScore}</h5>
          </div>
          <div className="flex flex-col items-center">
            <h3>Efficiency Score</h3>
            <h5>{efficiencyScore}</h5>
          </div>
        </div>
      </div>
    </div>
  );
};

export default CheckInCard;
